module.exports = __webpack_public_path__ + "img/flammable.6d2e2e1c.svg";